var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bad-words-indicator"},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('div',_vm._g(_vm._b({staticClass:"indicator-square",class:_vm.indicatorStatus},'div',attrs,false),on))]}}])},[_c('span',[_vm._v(_vm._s(_vm.indicatorTooltip))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }